/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

export interface ShowCopilotFunctionalityInIssuesOptions {
  additionalConditions?: boolean[]
  repositoryVisibility: string
  userCanPushToRepo: boolean
  /**
   * Optional chat mode string. Pass the current copilot chat mode (e.g. 'immersive')
   * so the hook can suppress copilot UI when the full chat is open.
   * When omitted the immersive-mode check is skipped, avoiding the heavy
   * @github-ui/copilot-chat import.
   */
  chatMode?: string
}

/**
 * Lightweight hook that checks whether Copilot functionality should be shown
 * on issues pages. This avoids importing the full @github-ui/copilot-chat
 * module graph (~700KB) that the original hook in @github-ui/issue-create
 * pulls in via useSafeChatState.
 */
export function useShouldShowCopilotFunctionalityInIssues({
  additionalConditions = [],
  repositoryVisibility,
  userCanPushToRepo,
  chatMode,
}: ShowCopilotFunctionalityInIssuesOptions): boolean {
  const appPayload = useAppPayload<{current_user_settings?: {copilot_show_functionality?: boolean}}>()
  if (chatMode === 'immersive') return false
  if (!appPayload?.current_user_settings?.copilot_show_functionality) return false
  if (repositoryVisibility === 'PUBLIC' && !userCanPushToRepo) return false
  return additionalConditions.every(condition => condition)
}
